import { PAGE_CONTACTS } from '../types'

const defaultState = null

export default function reduceCursor(
  state = defaultState,
  { type, payload = {} }
) {
  if (type === PAGE_CONTACTS) return payload
  return state
}
